import React from "react";
import { Link } from "react-router-dom";
import { Compass } from "lucide-react";
import Seo from "@/components/Seo";
import { Button } from "@/components/ui/button";

/**
 * NotFound — catch-all 404 page.
 *
 * Marked `noindex, nofollow` so Google removes any phantom / mistyped URL from
 * its index and stops wasting crawl budget on it (was previously served the
 * homepage with a `200 OK` → soft-404).
 */
export default function NotFound() {
    return (
        <div className="min-h-screen flex flex-col items-center justify-center gap-6 px-6 text-center" data-testid="page-not-found">
            <Seo
                title="Page introuvable · Foundation of Light"
                description="Cette page n'existe pas ou plus. Retour à l'accueil."
                path=""
                noindex
            />
            <Compass className="w-14 h-14 text-primary/70" strokeWidth={1.4} aria-hidden />
            <h1 className="font-serif text-4xl sm:text-5xl leading-tight">Cette page n'existe pas</h1>
            <p className="text-muted-foreground max-w-xl">
                Le lien que vous avez suivi a peut-être expiré, été renommé ou n'existe pas.
                Laissez-vous porter — l'essentiel se trouve toujours sur l'accueil.
            </p>
            <div className="flex flex-wrap gap-3 justify-center pt-2">
                <Link to="/"><Button className="rounded-full" data-testid="not-found-home">Retour à l'accueil</Button></Link>
                <Link to="/evenements"><Button variant="outline" className="rounded-full" data-testid="not-found-events">Voir les ateliers</Button></Link>
                <Link to="/journal"><Button variant="outline" className="rounded-full" data-testid="not-found-journal">Journal</Button></Link>
            </div>
        </div>
    );
}
